export default __webpack_public_path__ + "static/media/mobile_menu_white.5302f9f9.svg";